import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.125 5h3.354v1.313a.563.563 0 0 0 .96.397l1.876-1.875a.563.563 0 0 0 0-.795l-1.876-1.875a.563.563 0 0 0-.96.398v1.312H6.125A4.117 4.117 0 0 0 2 8a.563.563 0 0 0 1.125 0c0-1.655 1.345-3 3-3m7.313 2.438a.563.563 0 0 0-.563.562c0 1.655-1.346 3-3 3H6.5V9.688a.563.563 0 0 0-.96-.399l-1.876 1.875a.56.56 0 0 0 0 .796l1.875 1.875a.563.563 0 0 0 .961-.397v-1.313h3.375A4.13 4.13 0 0 0 14 8c0-.31-.25-.562-.562-.562"
    }, null, -1)
  ]))]))
}
export default { render: render }